<template>
  <div class="chb-section">
    <slot />
  </div>
</template>

<script>
export default {
  name: "ChbSection"
};
</script>
